import { useEffect } from 'react';
import swal from 'sweetalert';
import PropTypes from 'prop-types';
import { useBlocker } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { createSession } from '../../../store/actions/sessionActions';

const PreventTransitions = ({ message }) => {
  const isBlocking = useSelector(
    (state) => (state.session.isBlocking === undefined ? false : state.session.isBlocking),
  );
  const dispatch = useDispatch();

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return isBlocking && currentLocation.pathname !== nextLocation.pathname;
  });

  useEffect(() => {
    if (blocker.state === 'blocked') {
      swal({
        title: 'Wait',
        text: message,
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((ok) => {
        if (ok) {
          dispatch(createSession({ isBlocking: false }));
          blocker.proceed();
        } else {
          blocker.reset();
        }
      });
    }
  }, [blocker, dispatch, message]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!isBlocking) return;
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isBlocking]);

  return null;
};

PreventTransitions.propTypes = {
  message: PropTypes.string,
};

PreventTransitions.defaultProps = {
  message: 'You have unsaved changes, are you sure you want to leave?',
};

export default PreventTransitions;